import * as React from "react";
import { useCallback, useMemo } from "react";
import { makeVisualization, retrieveChartData } from "views/components/aggregationbuilder/AggregationBuilder";
import useChartData from "views/components/visualizations/useChartData";
import useEvents from "views/components/visualizations/useEvents";
import ScatterVisualizationConfig from "views/logic/aggregationbuilder/visualizations/ScatterVisualizationConfig";
import useChartDataSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartDataSettingsWithCustomUnits";
import useChartLayoutSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartLayoutSettingsWithCustomUnits";
import usePlotOnClickPopover from "views/components/visualizations/hooks/usePlotOnClickPopover";
import scatterOnClickPopover from "views/components/visualizations/scatter/scatterOnClickPopover";
import XYPlot from "../XYPlot";
const ScatterVisualization = makeVisualization(
  ({ config, data, effectiveTimerange, height, width }) => {
    var _a;
    const visualizationConfig = (_a = config.visualizationConfig) != null ? _a : ScatterVisualizationConfig.empty();
    const getChartDataSettingsWithCustomUnits = useChartDataSettingsWithCustomUnits({ config });
    const rows = useMemo(() => retrieveChartData(data), [data]);
    const seriesGenerator = useCallback(
      ({ type, name, labels, values, originalName, fullPath }) => ({
        type,
        name,
        x: labels,
        y: values,
        mode: "markers",
        originalName,
        ...getChartDataSettingsWithCustomUnits({ name, fullPath, values })
      }),
      [getChartDataSettingsWithCustomUnits]
    );
    const _chartDataResult = useChartData(rows, {
      widgetConfig: config,
      chartType: "scatter",
      generator: seriesGenerator
    });
    const { eventChartData, shapes } = useEvents(config, data.events);
    const chartDataResult = useMemo(
      () => eventChartData ? [..._chartDataResult, eventChartData] : _chartDataResult,
      [_chartDataResult, eventChartData]
    );
    const getChartLayoutSettingsWithCustomUnits = useChartLayoutSettingsWithCustomUnits({
      config,
      chartData: chartDataResult
    });
    const layout = useMemo(() => {
      var _a2;
      const _layouts = getChartLayoutSettingsWithCustomUnits();
      if (shapes) {
        _layouts.shapes = [...(_a2 = _layouts.shapes) != null ? _a2 : [], ...shapes];
      }
      return _layouts;
    }, [shapes, getChartLayoutSettingsWithCustomUnits]);
    const { popover, initializeGraphDivRef, onChartClick } = usePlotOnClickPopover({
      ...scatterOnClickPopover,
      config
    });
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      XYPlot,
      {
        config,
        axisType: visualizationConfig.axisType,
        chartData: chartDataResult,
        plotLayout: layout,
        height,
        width,
        effectiveTimerange,
        onClickMarker: onChartClick,
        onInitialized: initializeGraphDivRef
      }
    ), popover);
  },
  "scatter"
);
export default ScatterVisualization;
